module.exports = __webpack_public_path__ + "static/img/1_1_2_2.7ee16e83.jpg";